import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable()
export class NoTokenAuthGuard  {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate() {
    const validToken = this.authService.userHasValidAccessToken();
    if (validToken) {
      this.router.navigate(['/secure/dashboard']);
      return false;
    }
    return true;
  }
}
